export default __webpack_public_path__ + "static/couples-1e081adc11f90ac3da67e7fd427a74e6.svg";